<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Formulário de Solicitação</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <div class="grid grid-cols-2 gap-4">
                  <!-- CRIAÇÃO -->
                  <template v-if="tipoFormSolicitacao === 'criar'">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1">Título</label>
                      <input
                        v-model="formSolicitacao.titulo"
                        type="text"
                        class="block w-full border-0 border-b border-gray-300 py-2 pl-2 pr-2 text-sm text-gray-900 focus:ring-0 focus:border-blue-400"
                      />
                    </div>

                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                      <textarea
                        v-model="formSolicitacao.descricao"
                        rows="4"
                        class="block w-full border border-gray-300 rounded-md p-2 text-sm"
                      ></textarea>
                    </div>
                  </template>

                  <!-- ATENDIMENTO -->
                  <template v-else-if="tipoFormSolicitacao === 'atender'">
                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-1">Resposta</label>
                      <textarea
                        v-model="formSolicitacao.resposta"
                        rows="4"
                        class="block w-full border border-gray-300 rounded-md p-2 text-sm"
                      ></textarea>
                    </div>
                  </template>

                  <!-- CANCELAMENTO -->
                  <template v-else-if="tipoFormSolicitacao === 'cancelar'">
                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-1">Motivo do Cancelamento</label>
                      <textarea
                        v-model="formSolicitacao.motivo_cancelamento"
                        rows="4"
                        class="block w-full border border-gray-300 rounded-md p-2 text-sm"
                      ></textarea>
                    </div>
                  </template>

                  <div class="col-span-2 flex justify-end">
                    <button @click="createData" type="button" class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue">
                      {{ getBotaoTexto() }}
                    </button>
                  </div>

                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

  export default {
    name: 'SolicitacaoForm',
    emits:['update-open','create-new-request','create-new-response','cancel-request'],
    async created(){
        
    },
    props: {
      open: {
        type: Boolean,
        required: true
      },
      proposta:{
        type:Object,
        required:true
      },
      tipoFormSolicitacao:{
        type: String,
        required: true
      }
    },  
    watch: {
      resetFormData(newValue) { 
        if(newValue == true){
          this.data = {}
        }
      }
    }, 
    data() {
      return {
        data:{},
        formSolicitacao: {
          titulo: '',
          descricao: '',
          resposta: '',
          motivo_cancelamento: '',
          status: 'pendente',
        },
      };
    },
    methods: {
      closeDialog() {
        this.$emit('update-open', false);  // Emite um evento para o componente pai alterar a prop "open"
      },
      createData() {
        let payload = {};

        if (this.tipoFormSolicitacao === 'criar') {
          payload = {
            proposta_id: this.proposta.id,
            titulo: this.formSolicitacao.titulo,
            descricao: this.formSolicitacao.descricao
          };
          this.$emit('create-new-request', payload);
          this.$emit('update-open', false);

        } else if (this.tipoFormSolicitacao === 'atender') {
          payload = {
            proposta_id: this.proposta.id,
            resposta: this.formSolicitacao.resposta
          };
          this.$emit('create-new-response', payload);
          this.$emit('update-open', false);

        } else if (this.tipoFormSolicitacao === 'cancelar') {
          payload = {
            proposta_id: this.proposta.id,
            motivo_cancelamento: this.formSolicitacao.motivo_cancelamento
          };
          this.$emit('cancel-request', payload);
          this.$emit('update-open', false);
        }
      },
      getBotaoTexto() {
        if (this.tipoFormSolicitacao === 'criar') {
          return 'Criar Solicitação';
        } else if (this.tipoFormSolicitacao === 'atender') {
          return 'Responder Solicitação';
        } else if (this.tipoFormSolicitacao === 'cancelar') {
          return 'Cancelar Solicitação';
        } else {
          return 'Enviar';
        }
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
    },
  }
</script>